module.exports = __webpack_public_path__ + "static/media/testimonial-flood.0c841601.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/callouts/testimonial-flood.jpg
// module id = 1190
// module chunks = 0